module.exports = __webpack_public_path__ + "media/images/challenges/golden-ticket-22/submissions_border-8bcb730dc11bede6078444a15ebbf112.png";